import {BaseHook, Hook, HookClass, NickProcessArtfact} from '@mrp-brasil/nick-process-commons';
import {ICoreCrudService} from '@mrp-brasil/nick-node-commons';
import {ArtfactKind} from '@mrp-brasil/nick-data-commons';
import {Observable, of} from 'rxjs';
import {concatMap} from 'rxjs/operators';
import moment from 'moment';

@HookClass('cron')
export class CronHook extends BaseHook {
    @Hook('0cbb5273-bdf8-457b-8e8b-3aa011951b95')
    public checkConflict(inputArtifact: NickProcessArtfact): Observable<NickProcessArtfact> {
        // verificar se já existe registro com os dados informados
        return this.crud(inputArtifact.object.model)
            .pipe(concatMap((service: ICoreCrudService) => {
                const resultArtifact = new NickProcessArtfact();
                // selecionar todos os registros do key e período informado
                return this.crud(inputArtifact.object.model)
                    .pipe(concatMap((service: ICoreCrudService) => {

                        const uniqueFields = inputArtifact.object.data.uniqueFields;
                        const input: any = inputArtifact.object.data.input;
                        const whereClause: any = {$and: []};
                        // driverId: event.driverId,
                        for (let i = 0; i < uniqueFields.length; i++) {
                            const uniqueFieldClause: any = {};
                            uniqueFieldClause[uniqueFields[i]] = input[uniqueFields[i]];
                            whereClause.$and.push(uniqueFieldClause);
                        }

                        // caso input possua valor em todos os periodFields
                        // $or: [{
                        //     startDate: {
                        //         $between: [event.startDate, event.recurrenceEndDate],
                        //     }
                        // },
                        // {
                        //     recurrenceEndDate: {
                        //         $between: [event.startDate, event.recurrenceEndDate],
                        //     }
                        // }],
                        // caso input nao possua valor em todos os periodFields utilizamos startDateField e endDateField
                        // pois significa que não é um evento recorrente
                        // $or: [{
                        //     startDate: {
                        //         $between: [event.startDate, event.endDate],
                        //     }
                        // },
                        // {
                        //     endDate: {
                        //         $between: [event.startDate, event.endDate],
                        //     }
                        // }],
                        let periodFields = inputArtifact.object.data.periodFields;
                        const orClause: any = {$or: []};

                        // verifica se é evento periodico, se não for altera periodFields para startDateField e endDateField
                        for (let i = 0; i < periodFields.length; i++) {
                            if (!input[periodFields[i]]) {
                                periodFields = [inputArtifact.object.data.startDateField, inputArtifact.object.data.endDateField];
                                break;
                            }
                        }

                        for (let i = 0; i < periodFields.length; i++) {
                            const orItem: any = {};
                            const beetweenItem = [];
                            for (let j = 0; j < periodFields.length; j++) {
                                beetweenItem.push(input[periodFields[j]]);
                            }
                            orItem[periodFields[i]] = {
                                $between: beetweenItem
                            };
                            orClause.$or.push(orItem);
                        }
                        if (orClause.$or.length > 0) {
                            whereClause.$and.push(orClause);
                        }

                        // $or: [
                        //     { ownerEventId: { $is: null } },
                        //     { independent: true }
                        // ],
                        const parentField = inputArtifact.object.data.parentField;
                        const ignoreParentField = inputArtifact.object.data.ignoreParentField;
                        if (parentField) {
                            let parentClause: any = {};
                            parentClause[parentField] = {
                                $is: null
                            };

                            if (ignoreParentField) {
                                const ignoreParentClause: any = {};
                                ignoreParentClause[ignoreParentField] = {
                                    $eq: true
                                };
                                const _parentClause = parentClause;
                                parentClause = {$or: []};
                                parentClause.$or.push(_parentClause);
                                parentClause.$or.push(ignoreParentClause);
                            }
                            whereClause.$and.push(parentClause);
                        }
                        //     cron: {
                        //         $or: dayOfWeekWhereClause
                        //     }
                        const dayOfWeekField = inputArtifact.object.data.dayOfWeekField;
                        const cronField = inputArtifact.object.data.cronField;
                        if (dayOfWeekField) {
                            if (input[dayOfWeekField]) {
                                const dayOfWeekList = input[dayOfWeekField].split(',');
                                const dayOfWeekWhereClause = [];
                                for (let i = 0; i < dayOfWeekList.length; i++) {
                                    dayOfWeekWhereClause.push({$like: '%' + dayOfWeekList[i] + '%'});
                                }
                                const cronClause: any = {};
                                cronClause[cronField] = {
                                    $or: dayOfWeekWhereClause
                                };

                                whereClause.$and.push(cronClause);
                            }
                        }

                        // não incluir o proprio registro na consulta (update)
                        if (input.id) {
                            whereClause.$and.push({
                                id: {
                                    $ne: input.id
                                }
                            });
                        }

                        // com o driver informado
                        // no periodo de data informado
                        // somente eventos pais ou filhos avulsos
                        // somente cron que possuir pelo menos um dayOfWeek informado
                        return service.findAll(whereClause);
                    }))
                    // verificar se alguma registro está contemplado no periodo informado
                    .pipe(concatMap((records) => {
                        if (records.length > 0) {
                            const input = inputArtifact.object.data.input;
                            const startDate = moment(input[inputArtifact.object.data.startDateField]);
                            const endDate = moment(input[inputArtifact.object.data.endDateField]);
                            for (let i = 0; i < records.length; i++) {
                                const record = records[i];
                                const recordMoment = moment(record.startDate);
                                if (recordMoment.isBetween(startDate, endDate, null, '[]')) {
                                    const resultArtifact = new NickProcessArtfact();
                                    resultArtifact.kind = ArtfactKind.ERROR;
                                    resultArtifact.object.data = record.dataValues;
                                    return of(resultArtifact);
                                }
                            }
                        }
                        return of(resultArtifact);
                    }));
            }));
    }

    @Hook('34afccc2-87bb-4666-8311-6979080d722d')
    public configureExpression(inputArtifact: NickProcessArtfact): Observable<NickProcessArtfact> {

        return of(inputArtifact)
            .pipe(concatMap(() => {
                const outputArtifact = new NickProcessArtfact();
                outputArtifact.kind = ArtfactKind.ANY;
                outputArtifact.object = {};

                const seconds = inputArtifact.object.seconds;
                const minutes = inputArtifact.object.minutes;
                const hours = inputArtifact.object.hours;
                const days = inputArtifact.object.days;
                const months = inputArtifact.object.months;
                const years = inputArtifact.object.years;

                let secondsExpression = '* ';
                let minutesExpression = '* ';
                let hoursExpression = '* ';
                let daysExpression = '? ';
                let monthsExpression = '* ';
                let dayOfWeekExpression = '* ';
                let yearsExpression = '*';

                if (seconds?.everySecondStartingAt) {
                    secondsExpression = seconds.secondGap + '/' + seconds.secondLapse + ' ';
                } else if (seconds?.specificSecond) {

                    if(seconds.specificSecondSelection instanceof Array)
                        seconds.specificSecondSelection = seconds.specificSecondSelection.toString();

                    secondsExpression = seconds.specificSecondSelection + ' ';
                } else if (seconds?.everySecondBetween) {
                    secondsExpression = seconds.firstSecondBetween + '-' + seconds.secondSecondBetween + ' ';
                }

                if (minutes?.everyMinuteStartingAt) {
                    minutesExpression = minutes.minuteGap + '/' + minutes.minuteLapse  + ' ';
                } else if (minutes?.specificMinute) {

                    if(minutes.specificMinuteSelection instanceof Array)
                        minutes.specificMinuteSelection = minutes.specificMinuteSelection.toString();

                    minutesExpression = minutes.specificMinuteSelection + ' ';
                } else if (minutes?.everyMinuteBetween) {
                    minutesExpression = minutes.firstMinuteBetween + '-' + minutes.secondMinuteBetween + ' ';
                }

                if (hours?.everyHourStartingAt) {
                    hoursExpression = hours.hourLapse + '/' + hours.hourGap + ' ';
                } else if (hours?.specificHour) {

                    if(hours.specificHourSelection instanceof Array)
                        hours.specificHourSelection = hours.specificHourSelection.toString();

                    hoursExpression = hours.specificHourSelection + ' ';
                } else if (hours?.everyHourBetween) {
                    hoursExpression = hours.firstHourBetween + '-' + hours.secondHourBetween + ' ';
                }



                if (days?.everyDayStartingOnWeekDay) {
                    dayOfWeekExpression = days.everyDayStartingOnWeekDay1 + '/' + days.everyDayStartingOnWeekDay2 + ' ';
                } else if (days?.everyDayStartingOnOrdinalDay) {
                    daysExpression = days.everyDayStartingOnOrdinalDay1 + '/' + days.everyDayStartingOnOrdinalDay2 + ' ';
                    dayOfWeekExpression = '? ';
                } else if (days?.specificDayOfWeek) {

                    if( days.specificDaySelection instanceof Array)
                        days.specificDaySelection = days.specificDaySelection.toString();


                    daysExpression = '? ';
                    dayOfWeekExpression = days.specificDaySelection + ' ';
                } else if (days?.specificDayOfMonth) {

                    if( days.specificDaysSelection instanceof Array)
                        days.specificDaysSelection = days.specificDaysSelection.toString();

                    daysExpression = days.specificDaysSelection + ' ';
                    dayOfWeekExpression = '? ';
                } else if (days?.lastDayOfMonth) {
                    daysExpression = 'L ';
                    dayOfWeekExpression = '? ';
                } else if (days?.lastWeekdayOfMonth) {
                    daysExpression = 'LW ';
                    dayOfWeekExpression = '? ';
                } else if (days?.lastOrdinalDayOfMonth) {
                    daysExpression = '? ';
                    dayOfWeekExpression = days.lastOrdinalDayOfMonth1 + 'L ';
                } else if (days?.lastDayBeforeEndOfMonth) {
                    daysExpression = 'L-' + days.lastDayBeforeEndOfMonth1 + ' ';
                    dayOfWeekExpression = '? ';
                } else if (days?.nearestWeekdayToOrdinalDay) {
                    daysExpression = days.nearestWeekdayToOrdinalDay1 + 'W ';
                    dayOfWeekExpression = '? ';
                } else if (days?.firstOrdinalDayOfMonth) {
                    daysExpression = '? ';
                    dayOfWeekExpression = days.firstOrdinalDayOfMonth2 + '#' + days.firstOrdinalDayOfMonth1 + ' ';
                }



                if (months?.everyMonthStartingAt) {
                    monthsExpression = months.everyDaysStartingAtNumber + '/' + months.everyDaysNumber + ' ';
                } else if (months?.everyMonthStartingAtDay) {

                    if(months.specificMonthSelection instanceof Array)
                        months.specificMonthSelection = months.specificMonthSelection.toString();

                    monthsExpression = months.specificMonthSelection + ' ';
                } else if (months?.everyMonthBetween) {
                    monthsExpression = months.everyDaysNumber2 + '-' + months.everyDaysStartingAtOrdinalDay + ' ';
                }

                if (years?.everyYearStartingAt) {
                    yearsExpression = years.everyYearsStartingAtNumber + '/' + years.everyYearsNumber + ' ';
                } else if (years?.specificYear) {
                    if(years.specificYearsSelection instanceof Array)
                        years.specificYearsSelection = years.specificYearsSelection.toString();

                    yearsExpression = years.specificYearsSelection + ' ';
                } else if (years?.everyYearBetween) {
                    yearsExpression = years.everyYearBetweenFirstNumber + '-' + years.everyYearBetweenSecondNumber;
                }

                outputArtifact.object = secondsExpression + minutesExpression + hoursExpression + daysExpression +
                    monthsExpression + dayOfWeekExpression + yearsExpression;

                return of(outputArtifact);

            }));

    }

}
